import React from "react";
import { withTranslation } from "react-i18next";

class ExaminationInstanceSubmissionCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      interval: null,
      currentTimeString: "",
      showUpdate: false
    };

    this.timeUnits = ["sec", "min", "h"];
    this.dividers = [60, 60];

    this.updateClock = this.updateClock.bind(this);
  }

  componentDidMount() {
    if (
      this.props.submission &&
      this.props.submission.examinationStatus === 11
    ) {
      const interval = setInterval(this.updateClock, 1000);
      this.setState({ interval: interval });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.submission &&
      prevProps.submission &&
      this.props.submission.examinationStatus === 11 &&
      !this.props.submission.firstLoad &&
      this.props.submission.date !== prevProps.submission.date
    ) {
      this.setState({ showUpdate: true });
      setTimeout(() => this.setState({ showUpdate: false }), 5000);
    }

    if (
      this.props.submission &&
      prevProps.submission &&
      this.props.submission.examinationStatus !==
      prevProps.submission.examinationStatus
    ) {
      if (
        this.props.submission &&
        prevProps.submission &&
        prevProps.submission.examinationStatus !== 11 &&
        this.props.submission.examinationStatus === 11
      ) {
        const interval = setInterval(this.updateClock, 1000);
        this.setState({ interval: interval });
      } else if (
        this.props.submission &&
        prevProps.submission &&
        prevProps.submission.examinationStatus === 11 &&
        this.props.submission.examinationStatus !== 11
      ) {
        if (this.state.interval) {
          clearInterval(this.state.interval);
          this.setState({ interval: null });
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.state.interval) {
      clearInterval(this.state.interval);
      this.setState({ interval: null });
    }
  }

  updateClock() {
    if (this.props.submission.isInit) return;
    let date = this.props.submission.date;
    if (!(date instanceof Date)) date = new Date(Date.parse(date));
    let delta = (Date.now() - date.getTime()) / 1000;
    let ct = 0;
    while (delta > this.dividers[ct] && ct < this.dividers.length) {
      delta = delta / this.dividers[ct];
      ct++;
    }
    this.setState({
      currentTimeString: `${Math.floor(delta)} ${this.timeUnits[ct]}`
    });
  }

  render() {
    let status = "-";
    if (this.props.submission
        && this.props.instance !== null
        && Array.isArray(this.props.instance.storage)
        && this.props.instance.storage.length > 0
        && Object.keys(this.props.instance.storage[0]).length !== 0) {
      const date =
        this.props.submission.date instanceof Date
          ? this.props.submission.date
          : new Date(Date.parse(this.props.submission.date));
      switch (this.props.submission.examinationStatus) {
        case 11:
          if (!this.props.submission.isInit && this.props.instance.attendedAt !== null) {
            status = this.state.currentTimeString;
          }
          break;
        case 20:
        case 21:
        case 30:
        case 31:
        case 32:
        case 60:
        case 61:
          status =
            ("0" + date.getDate()).slice(-2) +
            "." +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "." +
            date.getFullYear() +
            " " +
            ("0" + date.getHours()).slice(-2) +
            ":" +
            ("0" + date.getMinutes()).slice(-2);
          break;
        default:
          status = "-";
          break;
      }
    }
    return (
      <span>
        {this.state.showUpdate && status !== "-" ? (
          <b className="color-green">{status}</b>
        ) : (
          status
        )}
      </span>
    );
  }
}

export default withTranslation()(ExaminationInstanceSubmissionCell);
